/* eslint-disable complexity */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
var useStyles = makeStyles(function (theme) { return ({
    button: function (style) { return ({
        margin: (style && style.margin) || theme.spacing(1),
        color: theme.palette.common.white,
        background: (style && style.background) || theme.palette.primary.main,
        fontSize: (style && style.textSize) || '10px',
        '&:hover': {
            backgroundColor: "".concat((style && style.background) || theme.palette.primary.main, "d1"),
        },
        padding: '5px 15px',
    }); },
    span: function () { return ({
        lineHeight: 1,
        paddingLeft: 5,
    }); },
    icon: function (style) { return ({
        fontSize: (style && style.iconSize) || '1.2em',
    }); },
}); });
/**
 * @deprecated
 * Use `IconButtonWithLabel` to render a button with icon and text inside your project
 */
function IconButtonWithLabel(props) {
    var style = props.style, disabled = props.disabled, icon = props.icon, variant = props.variant, onButtonClick = props.onButtonClick, size = props.size, children = props.children, elementId = props.elementId;
    var classes = useStyles(style);
    var TheIcon = icon;
    return (React.createElement(Button, { size: size, variant: variant, className: classes.button, disableRipple: true, disabled: disabled, "data-testid": elementId, onClick: onButtonClick },
        icon ? React.createElement(TheIcon, { className: classes.icon }) : null,
        React.createElement("span", { className: classes.span }, children)));
}
IconButtonWithLabel.defaultProps = {
    variant: 'contained',
    elementId: '',
};
export default IconButtonWithLabel;
//# sourceMappingURL=IconButtonWithLabel.js.map